import React, { useContext } from 'react';
import {
  ProductMasterDataExportConfiguration,
  ProductMasterDataExportConfigurationField,
  ProductMasterDataExportConfigurationInput,
} from '../../../../../../../types/product_master_data_export_configuration';
import NotFound from '../../../../../../components/NotFound/NotFound';
import { DraggableItemData } from '../../../../../Common/DraggableItem';
import { CustomFieldContext } from '../../../../../../../context/CustomFieldContext';
import { CustomFieldEntityType } from '../../../../../../../types/custom_field';
import ExportConfigurationForm, {
  DraggableExportFieldIdentifier,
} from '../../../../../../components/Export/ExportConfigurationForm';
import { translate } from '../../../../../../../types/translation/Translator';

interface ProductMasterDataExportConfigurationMapping {
  value: string;
  index: number;
  field: ProductMasterDataExportConfigurationField;
}

export interface DraggableProductMasterDataExportFieldIdentifier
  extends DraggableExportFieldIdentifier<ProductMasterDataExportConfigurationField>,
    ProductMasterDataExportConfigurationMapping {}

interface ProductExportConfigurationFormProps {
  input: ProductMasterDataExportConfigurationInput;
  setInput: React.Dispatch<React.SetStateAction<ProductMasterDataExportConfigurationInput>>;
  footer: (
    configuration: ProductMasterDataExportConfigurationInput,
    items: DraggableProductMasterDataExportFieldIdentifier[],
  ) => JSX.Element;
  loading?: boolean;
}

export default function ProductExportConfigurationForm({
  input,
  setInput,
  footer,
  loading = false,
}: ProductExportConfigurationFormProps) {
  if (!input) return <NotFound />;

  const { customFields } = useContext(CustomFieldContext);

  const draggableItems: DraggableProductMasterDataExportFieldIdentifier[] =
    DraggableItemData.forExportConfiguration<ProductMasterDataExportConfigurationField>([
      ...Object.values(ProductMasterDataExportConfigurationField).map(field => ({
        field,
        label: translate({ key: field }),
      })),
      ...[...customFields.values()]
        .filter(item => item.entityType === CustomFieldEntityType.productMasterData)
        .map(item => ({ field: item.id, label: item.name })),
    ]);

  return (
    <ExportConfigurationForm
      placeholder={'Add product reference data export field'}
      loading={loading}
      input={input}
      setInput={setInput}
      footer={footer}
      draggableItems={draggableItems}
      toDraggableItems={ProductMasterDataExportConfiguration.toDraggableItems}
    />
  );
}
